import EmptyStateContent, { EmptyStateContentProps } from './EmptyStateContent';

export type { EmptyStateContentProps };
export default EmptyStateContent;
